import { LoadingLazyComponents, NotFoundPage } from "@hoa00/i24-core-ui";
import { FC, lazy } from "react";
import { Route, Routes } from "react-router-dom";

const ListPage = lazy(() => import("./pages/ContactList"));
const Create = lazy(() => import("./pages/ContactCreate"));
const UpdatePage = lazy(() => import("./pages/ContactUpdate"));
const ContactTypeRouters = lazy(
  () => import("./modules/contact-type/ContactTypeRouters")
);

const SalesProductRouters: FC = () => {
  return (
    <Routes>
      <Route
        path="/type/*"
        element={<LoadingLazyComponents children={<ContactTypeRouters />} />}
      />
      <Route
        path="/"
        element={<LoadingLazyComponents children={<ListPage />} />}
      />
      <Route
        path="/create"
        element={<LoadingLazyComponents children={<Create />} />}
      />
      <Route
        path="/update/:itemId"
        element={<LoadingLazyComponents children={<UpdatePage />} />}
      />

      {/* Fallback Not found pages */}
      <Route
        path="*"
        element={<LoadingLazyComponents children={<NotFoundPage />} />}
      />
    </Routes>
  );
};

export default SalesProductRouters;
